import React from 'react';
import { SnackbarComponent, SnackbarType } from './snackBarComponent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import {
  setErrorMessage,
  setInfoMessage,
  setSuccessMessage,
  setWarningMessage,
} from '../../Redux/Slices/alert.slice';

export const SnackBarWrapper = () => {
  const dispatch = useDispatch();

  const successMessage = useSelector(
    (state: RootState) => state.alert.successMessage
  );
  const errorMessage = useSelector(
    (state: RootState) => state.alert.errorMessage
  );
  const warningMessage = useSelector(
    (state: RootState) => state.alert.warningMessage
  );
  const infoMessage = useSelector(
    (state: RootState) => state.alert.infoMessage
  );
  return (
    <>
      <SnackbarComponent
        type={SnackbarType.SUCCESS}
        message={successMessage}
        open={successMessage !== null}
        onClose={() => {
          dispatch(setSuccessMessage(null));
        }}
      />
      <SnackbarComponent
        type={SnackbarType.ERROR}
        message={errorMessage}
        open={errorMessage !== null}
        onClose={() => {
          dispatch(setErrorMessage(null));
        }}
      />
      <SnackbarComponent
        type={SnackbarType.INFO}
        message={infoMessage}
        open={infoMessage !== null}
        onClose={() => {
          dispatch(setInfoMessage(null));
        }}
      />
      <SnackbarComponent
        type={SnackbarType.WARNING}
        message={warningMessage}
        open={warningMessage !== null}
        onClose={() => {
          dispatch(setWarningMessage(null));
        }}
      />
    </>
  );
};
